import { render, staticRenderFns } from "./icon-configurator-frequence-rarely.svg?vue&type=template&id=55526ff2&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports